import { render, staticRenderFns } from "./DeleteEntityButton.vue?vue&type=template&id=fbe8a89c&"
import script from "./DeleteEntityButton.vue?vue&type=script&lang=js&"
export * from "./DeleteEntityButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports